/* jp-motion · the prototype's (R26b) motion, on every page:
   1. page open: the top of the page fades and rises in, item by item (html.jp-anim → html.jp-in)
   2. cards fade in as they scroll into view, a few at a time
   3. day bars grow when the chart comes into view
   4. "Develops in 24–48 hours": drag the photo or the bar; plays once from the first stage to the last in view
   Everything is off with reduced motion. Theme-only: no engine hooks are read or written here. */
(function () {
  'use strict';
  var root = document.documentElement;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.2,.8,.2,1)';
  function clamp(v, a, b) { a = a === undefined ? 0 : a; b = b === undefined ? 1 : b; return Math.min(b, Math.max(a, v)); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function io(fn, opts) { return 'IntersectionObserver' in window ? new IntersectionObserver(fn, opts) : null; }

  /* 1. page open */
  function opened() {
    if (root.classList.contains('jp-in')) return;
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('jp-in'); }); });
  }

  /* 2. cards */
  var cardIO = calm ? null : io(function (entries) {
    var batch = 0;
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target;
      el.style.setProperty('--o', String(Math.min(batch, 10)));
      batch += 1;
      el.classList.add('in');
      cardIO.unobserve(el);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
    function cards(scope) {
    each((scope || document).querySelectorAll('.pin, .jp-library-card, .scard'), function (el) {
      if (el.getAttribute('data-jp-seen')) return;
      el.setAttribute('data-jp-seen', '1');
      if (cardIO && root.classList.contains('jp-anim')) cardIO.observe(el); else el.classList.add('in');
    });
  }

  /* 3. charts */
  var chartIO = calm ? null : io(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      each(en.target.querySelectorAll('.tr i, .jp-ser-bar i, .iwb i, .jps-bar i'), function (bar, k) { bar.style.setProperty('--o', String(k)); });
      en.target.classList.add('in');
      chartIO.unobserve(en.target);
    });
  }, { threshold: 0.25 });
  function charts(scope) {
    each((scope || document).querySelectorAll('.chart, .jp-ser-chart, .jps-wear, .iwear'), function (el) {
      if (el.getAttribute('data-jp-seen')) return;
      el.setAttribute('data-jp-seen', '1');
      if (chartIO && root.classList.contains('jp-anim')) chartIO.observe(el); else el.classList.add('in');
    });
  }

  /* 4. develop slider */
  function wireDev(dev) {
    if (dev.getAttribute('data-jp-dev-ready')) return;
    dev.setAttribute('data-jp-dev-ready', '1');
    var st = dev.querySelector('.devst');
    var trk = dev.querySelector('.trk');
    var sets = dev.querySelectorAll('.devim');
    var key = dev.querySelector('.devk');
    var cap = dev.querySelector('.devcap');
    var stops = dev.querySelector('.stops');
    if (!st || !sets.length) return;
    dev.classList.add('js');
    var di = 0, t = 1, anim = 0, played = false;
    var hint = cap ? cap.getAttribute('data-hint') : '';

    function frames() { return sets[di] ? sets[di].querySelectorAll('img') : []; }
    function labels() { return (sets[di].getAttribute('data-stages') || '').split('|'); }
    function render() {
      var fr = frames(), n = fr.length;
      if (!n) return;
      var p = t * (n - 1), lo = Math.floor(Math.min(p, n - 1.0001)), f = p - lo;
      if (n === 1) { lo = 0; f = 0; }
      each(fr, function (x, k) {
        x.style.opacity = k === lo ? 1 : (k === lo + 1 ? f : 0);
        x.style.zIndex = k === lo + 1 ? 2 : 1;
      });
      var r = Math.round(p), lb = labels();
      if (key) key.textContent = lb[r] || '';
      if (trk) {
        var th = trk.querySelector('.th'), fil = trk.querySelector('.fil');
        if (th) th.style.left = (t * 100) + '%';
        if (fil) fil.style.width = (t * 100) + '%';
      }
      if (stops) each(stops.querySelectorAll('button'), function (b, k) { b.classList.toggle('on', k === r); });
    }
    function go(to, ms) {
      cancelAnimationFrame(anim);
      if (calm) { t = to; render(); return; }
      var from = t, t0 = performance.now();
      (function step(now) {
        var k = clamp((now - t0) / ms), e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        t = from + (to - from) * e;
        render();
        if (k < 1) anim = requestAnimationFrame(step);
      })(t0);
    }
    function load(i) {
      di = i;
      each(sets, function (s, k) { s.hidden = k !== i; });
      var lb = labels();
      if (stops) {
        stops.innerHTML = '';
        lb.forEach(function (l, k) {
          var b = document.createElement('button');
          b.type = 'button'; b.setAttribute('data-st', String(k)); b.textContent = l;
          stops.appendChild(b);
        });
        stops.parentNode.hidden = lb.length < 2;
      }
      if (cap) {
        var c = sets[i].getAttribute('data-cap') || '';
        cap.textContent = c && hint && lb.length > 1 ? c + ' · ' + hint : c;
      }
      each(dev.querySelectorAll('.devc .chip'), function (c, k) {
        c.classList.toggle('on', k === i);
        c.setAttribute('aria-pressed', k === i ? 'true' : 'false');
      });
      t = 0;
      render();
    }
    function drag(el, scale) {
      if (!el) return;
      var on = false, x0 = 0, t0 = 0;
      el.addEventListener('pointerdown', function (e) {
        on = true; cancelAnimationFrame(anim);
        try { el.setPointerCapture(e.pointerId); } catch (_) {}
        var r = trk.getBoundingClientRect();
        if (scale) t = clamp((e.clientX - r.left) / r.width);
        x0 = e.clientX; t0 = t; render();
      });
      el.addEventListener('pointermove', function (e) {
        if (!on) return;
        var r = (scale ? trk : el).getBoundingClientRect();
        t = scale ? clamp((e.clientX - r.left) / r.width) : clamp(t0 + (e.clientX - x0) / r.width);
        render();
      });
      function up() {
        if (!on) return;
        on = false;
        var n = frames().length - 1;
        if (n > 0) go(Math.round(t * n) / n, 260);
      }
      el.addEventListener('pointerup', up);
      el.addEventListener('pointercancel', up);
    }
    if (trk) drag(trk, true);
    drag(st, false);
    dev.addEventListener('click', function (e) {
      var c = e.target.closest('[data-dv]');
      if (c) { load(+c.getAttribute('data-dv')); go(1, 2400); played = true; return; }
      var s = e.target.closest('[data-st]');
      if (s) { var n = frames().length - 1; if (n > 0) go(+s.getAttribute('data-st') / n, 420); }
    });
    dev.addEventListener('keydown', function (e) {
      if (!e.target.closest('.stops, .trk')) return;
      var n = frames().length - 1; if (n < 1) return;
      var r = Math.round(t * n);
      if (e.key === 'ArrowRight') { go(Math.min(n, r + 1) / n, 300); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { go(Math.max(0, r - 1) / n, 300); e.preventDefault(); }
    });
    load(0);
    if (calm) { t = 1; render(); return; }
    var obs = io(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting && !played) {
          played = true; obs.disconnect();
          setTimeout(function () { go(1, 2400); }, 300);
        }
      });
    }, { threshold: 0.5 });
    if (obs) obs.observe(st); else { t = 1; render(); }
  }
  function devs(scope) { each((scope || document).querySelectorAll('[data-jp-dev]'), wireDev); }

  function all(scope) { cards(scope); charts(scope); devs(scope); }
  function start() {
    all(document);
    opened();
    if ('MutationObserver' in window) {
      var pending = 0;
      new MutationObserver(function () {
        if (pending) return;
        pending = requestAnimationFrame(function () { pending = 0; cards(document); devs(document); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  window.JPMotion = { refresh: function (scope) { all(scope || document); }, ease: EASE, calm: calm };
})();
